// extracted by mini-css-extract-plugin
export default {"panel":"InstructionsToUse_panel__iycBu","heading":"InstructionsToUse_heading__k5slm","content":"InstructionsToUse_content__vDx78"};